import { render } from "./DocumentPreviewModal.vue?vue&type=template&id=d5353e36&scoped=true"
import script from "./DocumentPreviewModal.vue?vue&type=script&lang=js"
export * from "./DocumentPreviewModal.vue?vue&type=script&lang=js"

import "./DocumentPreviewModal.vue?vue&type=style&index=0&id=d5353e36&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d5353e36"]])

export default __exports__